<agpr-dialog-container
    [id]="'socialBulkActionsDialog'"
    heading="Social.postFeed.bulkActions.header"
    (close)="closeDialog(null)"
    class="agpr-socialBulkActionsDialog"
>
    <agpr-scroll-panel>
        <div class="agpr-socialBulkActionsDialog-content">
            <agpr-dropdown
                class="agpr-socialBulkActionsDialog-bulkActionDropdown"
                [id]="'socialBulkActionsDialog_chooseAction'"
                [options]="bulkActionDropdownOptions"
                [bindToValue]="true"
                [disabled]="previewCount === 0"
                [agprStyle]="agprComponentStyle.social"
                placeholder="Social.postFeed.bulkActions.dropdownOptionPlaceholder.selectAnAction"
                [(ngModel)]="selectedBulkAction"
                (ngModelChange)="bulkActionChanged()"
                [label]="'Social.postFeed.bulkActions.inputControlLabel.chooseAction' | localize | uppercase"
            ></agpr-dropdown>
            <agpr-dropdown
                [id]="'socialBulkActionsDialog_exportOptions'"
                *ngIf="selectedBulkAction === socialBulkActions.EXPORT"
                class="agpr-socialBulkActionsDialog-exportOptionsDropdown"
                [options]="postExportOptions"
                [bindToValue]="true"
                [disabled]="previewCount === 0"
                [agprStyle]="agprComponentStyle.social"
                placeholder="Social.postFeed.bulkActions.dropdownOptionPlaceholder.selectAFileType"
                ariaLabel="Social.postFeed.bulkActions.dropdownOptionPlaceholder.selectAFileType"
                [(ngModel)]="selectedExportFileType"
                (ngModelChange)="updateActionButtonState()"
            ></agpr-dropdown>

            <div
                *ngIf="selectedBulkAction === socialBulkActions.EXPORT"
                class="agpr-socialBulkActionsDialog-message"
            >
                <agpr-unsaved-export-info-message
                    [mentionCount]="previewCount"
                    [unsavedMentionExportLimit]="unsavedMentionExportLimit"
                    [unsavedMentionQuotaUsage]="unsavedMentionQuotaUsage"
                    [remainingUnsavedMentionQuota]="remainingUnsavedMentionQuota"
                    [mentionType]="mentionType"
                >
                </agpr-unsaved-export-info-message>
            </div>

            <div
                class="agpr-socialBulkActionsDialog-choosePosts"
                role="radiogroup"
                [attr.aria-label]="'Social.postFeed.bulkActions.inputControlLabel.choosePosts' | localize"
            >
                <label class="agpr-socialBulkActionsDialog-choosePostsLabel">{{ 'Social.postFeed.bulkActions.inputControlLabel.choosePosts' | localize | uppercase }}</label>
                <agpr-radio
                    [id]="'socialBulkActionsDialog_selectedPosts'"
                    label="Social.postFeed.bulkActions.inputControlLabel.currentlySelectedPosts"
                    hiddenLabel="Social.postFeed.bulkActions.inputControlLabel.currentlySelectedPosts"
                    [value]="socialBulkActionSourceMethods.SELECTION"
                    name="source_selection"
                    [disabled]="selectedResults.length === 0"
                    [agprStyle]="agprComponentStyle.social"
                    [(ngModel)]="selectedSourceMethod"
                    (ngModelChange)="sourceMethodChanged()"
                ></agpr-radio>
                <agpr-radio
                    [id]="'socialBulkActionsDialog_postsFromSource'"
                    label="Social.postFeed.bulkActions.inputControlLabel.postsFrom"
                    hiddenLabel="Social.postFeed.bulkActions.inputControlLabel.postsFrom"
                    [value]="socialBulkActionSourceMethods.SEARCH"
                    name="source_selection"
                    [agprStyle]="agprComponentStyle.social"
                    [(ngModel)]="selectedSourceMethod"
                    (ngModelChange)="sourceMethodChanged()"
                ></agpr-radio>
            </div>

            <div
                class="agpr-socialBulkActionsDialog-sourcePicker-container"
                *ngIf="selectedSourceMethod === socialBulkActionSourceMethods.SEARCH"
            >
                <div class="agpr-socialBulkActionsDialog-sourcePicker">
                    <div class="agpr-socialBulkActionsDialog-sourcePicker-toolbar" role="group" [attr.aria-describedby]="'socialBulkActionsDialog.sourceFilter.chips'">
                        <agpr-dropdown
                            [id]="'socialBulkActionsDialog_sourceType'"
                            class="agpr-socialBulkActionsDialog-sourcePicker-sourceType"
                            [options]="sourceTypeDropdownOptions"
                            [bindToValue]="true"
                            [agprStyle]="agprComponentStyle.social"
                            ariaLabel="Social.postFeed.bulkActions.inputControlLabel.selectSourceType"
                            [disabled]="selectedSourceType === socialBulkActionSourceType.ARCHIVE"
                            [(ngModel)]="selectedSourceType"
                            (ngModelChange)="sourceTypeChanged()"
                        ></agpr-dropdown>
                        <agpr-dropdown
                            [id]="'socialBulkActionsDialog_source'"
                            class="agpr-socialBulkActionsDialog-sourcePicker-source"
                            [options]="sourceOptions"
                            [bindToValue]="true"
                            [agprStyle]="agprComponentStyle.social"
                            ariaLabel="Social.postFeed.bulkActions.inputControlLabel.selectSource"
                            [(ngModel)]="selectedSource"
                            [disabled]="selectedSourceType === socialBulkActionSourceType.ARCHIVE"
                            (ngModelChange)="sourceChanged()"
                        ></agpr-dropdown>
                        <agpr-button
                            icon="fa-regular fa-duotone fa-filter"
                            [style]="buttonTypes.icon"
                            [disabled]="selectedSourceType === socialBulkActionSourceType.ARCHIVE"
                            tooltip="Core.button.filter"
                            (click)="openFilterWidget()"
                        ></agpr-button>
                    </div>
                    <agpr-filter-chips
                        class="agpr-socialBulkActionsDialog-sourcePicker-chips"
                        [id]="'socialBulkActionsDialog.sourceFilter.chips'"
                        [style]="agprComponentStyle.social"
                    ></agpr-filter-chips>
                </div>
                <agpr-date-query-popup
                    id="socialBulkActionsDialog.dateFilter"
                    class="agpr-socialBulkActionsDialog-datePicker"
                    [header]="'Monitoring.dateQueryDialog.header'"
                    [(ngModel)]="dateQuery"
                    [options]="dateOptions"
                    [toolTipLabel]="'Common.dateQueryInput.dateFilter'"
                    [searchRange]="searchRange"
                    [style]="agprComponentStyle.social"
                    (ngModelChange)="dateRangeChanged($event)"
                ></agpr-date-query-popup>
            </div>

            <div class="agpr-socialBulkActionsDialog-message">
                <agpr-message
                    *ngIf="previewCount !== null && (previewCount <= EXPORT_LIMIT || selectedBulkAction !== socialBulkActions.EXPORT)"
                    [severity]="messageSeverities.info"
                    [loading]="isSearchingPosts"
                >
                    <span>{{ 'Social.postFeed.bulkActions.message.normal' | localize : { count: previewCount } }}</span>
                </agpr-message>
                <agpr-message
                    *ngIf="previewCount > EXPORT_LIMIT && selectedBulkAction === socialBulkActions.EXPORT"
                    [severity]="messageSeverities.warning"
                    [loading]="isSearchingPosts"
                >
                    <div><b>{{ 'Social.postFeed.bulkActions.message.exceedExportLimit' | localize }}</b></div>
                    <span>{{ 'Social.postFeed.bulkActions.message.exceedExportLimit.detail' | localize : { count: previewCount, limit: EXPORT_LIMIT } }}</span>
                </agpr-message>
            </div>
        </div>
   </agpr-scroll-panel>

    <ng-template #footerLeft>
        <agpr-button
            label="cancel"
            [style]="buttonTypes.secondary"
            (click)="closeDialog(null)"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            *ngIf="!!selectedBulkAction"
            [label]="actionLabel"
            [disabled]="!canDoAction || isSearchingPosts"
            [style]="buttonTypes.primary"
            (click)="doAction()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
